// application configs
export const maxDbTableCellCountsToFetch = 100000 * 30; // rowCounts * colCounts

export const maxJsHeapSizeToRenderTable = 30 * 1024 * 1024 // limit to 30MB